import { Button } from '@/components/Button'
import { SquircleAdapter } from '@/components/SquircleAdapter'
import { useModal } from '@/hooks'
import { BiX } from 'react-icons/bi'
import { Resume } from '../Resume'

import './styles.scss'

interface ResumeModalProps {
  isOpen: boolean
  onClose: () => void
}

export function ResumeModal({ isOpen, onClose }: ResumeModalProps) {
  const { modalRef } = useModal({ isOpen, onClose })

  return (
    <>
      <div
        className="modal-overlay"
        onClick={onClose}
        data-open={isOpen}
        aria-hidden
      />

      <SquircleAdapter
        ref={modalRef}
        cornerRadius={0}
        topLeftCornerRadius={24}
        topRightCornerRadius={24}
        bottomLeftCornerRadius={0}
        bottomRightCornerRadius={0}
        className="modal"
        data-open={isOpen}
        role="dialog"
        aria-modal="true"
        aria-labelledby="resume-modal-title"
        tabIndex={-1}
      >
        <div className="modal__header">
          <Button
            className="modal__back-button"
            text="Fechar"
            variant="primary"
            leftRender={<BiX aria-hidden />}
            onClick={onClose}
            aria-label="Fechar resumo do pedido"
          />
        </div>

        <div className="modal__content">
          <div className="heading">
            <h2 id="resume-modal-title" className="resume-modal__title">
              Resumo do pedido
            </h2>
            <p>Confira os detalhes do seu pedido em tempo real.</p>
          </div>

          <Resume cornerRadius={0} />
        </div>
      </SquircleAdapter>
    </>
  )
}
